export function ParentInChain(theList, anObj) {
  var n = theList.length;
  for (var i = 0; i < n; i++) {
    var o = theList[i];
    if (o != anObj && anObj.InParentChain(o)) return true;
  }

  return false;
}
